module.exports = __webpack_public_path__ + "img/personaje-vista-2.6882445b.jpg";